"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemInfoBar = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var FavoriteButton_1 = require("./FavoriteButton");
var Flag_1 = require("./Flag");
var HiddenText_1 = require("./HiddenText");
var LiveStatusBug_1 = require("./LiveStatusBug");
var PerformerItemStarRating_1 = require("./PerformerItemStarRating");
var usePerformerItemInfoBarStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    "@keyframes streamPreviewLoadingAnimation": {
        from: {
            backgroundPosition: "50% 0%",
        },
        to: { backgroundPosition: "-250% 0%" },
    },
    detailsDivider: {
        color: theme.colors.baseContrast050,
        fontSize: "9px",
        padding: "0 3px",
        "&::before": {
            content: '"|"',
        },
    },
    detailsWrapper: {
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        fontSize: "10px",
        fontWeight: 500,
        justifyContent: "flex-start",
        lineHeight: 1.2,
        paddingBottom: "1px",
        paddingInlineEnd: "2px",
    },
    previewLoadingIndicator: {
        animationDelay: "100ms",
        animationDuration: "4s",
        animationIterationCount: "infinite",
        animationName: "$streamPreviewLoadingAnimation",
        animationTimingFunction: "linear",
        backgroundPosition: "50% 0%",
        backgroundRepeat: "repeat-x",
        backgroundSize: "300%",
        backgroundImage: "linear-gradient(\n    to right,\n    rgba(255, 255, 255, 0.25) 0%,\n    rgba(255, 255, 255, 0.2) 10%,\n    rgba(255, 255, 255, 0) 33%,\n    rgba(255, 255, 255, 0) 66%,\n    rgba(255, 255, 255, 0.2) 90%,\n    rgba(255, 255, 255, 0.25) 100%\n  )",
        position: "absolute",
        top: "16px" /* match with height of InfoBarUpper */,
        right: 0,
        bottom: 0,
        left: 0,
    },
    infoBarUpper: {
        background: "transparent",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        height: "16px",
        justifyContent: "flex-start",
        padding: "0 6px",
    },
    nickname: {
        boxSizing: "border-box",
        justifyContent: "flex-start",
        overflow: "hidden",
        paddingInlineStart: "2px",
        paddingInlineEnd: "4px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "100%",
    },
    infoBarMain: {
        alignItems: "center",
        fontWeight: 500,
        justifyContent: "flex-start",
        height: "28px",
    },
    infoBarMainSmall: {
        background: "rgba(0,0,0,0.3)",
    },
    infoBarMainLarge: {
        height: "26px",
    },
    infoBarLower: {
        alignItems: "flex-start",
        fontWeight: 400,
        height: "0",
        paddingBottom: "6px",
        transition: "height 0.25s ease-in-out",
    },
    infoBarLowerSmall: {
        background: "rgba(0,0,0,0.7)",
    },
    infoBarLowerHover: {
        height: "36px",
    },
    infoBarContainer: {
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        right: 0,
        bottom: 0,
        left: 0,
        "& $infoBarMain, & $infoBarLower": {
            boxSizing: "border-box",
            color: "#fff",
            display: "flex",
            flexDirection: "row",
            fontSize: "12px",
            lineHeight: 1.2,
            overflow: "hidden",
            padding: "0 6px",
            textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
        },
    },
    infoBarContainerLarge: {
        "& $infoBarMain, & $infoBarLower": {
            background: "rgba(0,0,0,0.3)",
        },
    },
    infoBarContainerLargeHover: {
        "& $infoBarMain, & $infoBarLower": {
            background: "rgba(0,0,0,0.5)",
        },
    },
}); });
var PerformerItemInfoBar = function (props) {
    var _a, _b, _c;
    var _d;
    var age = props.age, country = props.country, isFavorite = props.isFavorite, isHovering = props.isHovering, isOnline = props.isOnline, nickname = props.nickname, previewLoading = props.previewLoading, stars = props.stars, headline = props.headline, performerData = props.performerData;
    var _e = __read((0, Ioc_1.useContexts)(Contexts_1.ILayoutContext), 1), layout = _e[0];
    var _f = __read((0, Ioc_1.useContexts)(Contexts_1.IUserContext), 1), user = _f[0];
    var isLoading = (0, react_1.useMemo)(function () { return previewLoading && isHovering; }, [previewLoading, isHovering]);
    var classes = usePerformerItemInfoBarStyles();
    var isTextBlurEnabled = (_d = user === null || user === void 0 ? void 0 : user.ageVerificationRules) === null || _d === void 0 ? void 0 : _d.isTextBlurEnabled;
    var _onFavoriteIconClick = function (mouseEvent) {
        var _a;
        mouseEvent.preventDefault();
        mouseEvent.stopPropagation();
        (_a = props.onFavoriteIconClicked) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    var infoBarContainerClasses = (0, classnames_1.default)(classes.infoBarContainer, (_a = {},
        _a[classes.infoBarContainerLarge] = layout.breakpoint === "large",
        _a[classes.infoBarContainerLargeHover] = layout.breakpoint === "large" && isHovering,
        _a));
    var infoBarMainClasses = (0, classnames_1.default)(classes.infoBarMain, (_b = {},
        _b[classes.infoBarMainLarge] = layout.breakpoint === "large",
        _b[classes.infoBarMainSmall] = layout.breakpoint !== "large",
        _b));
    var infoBarLowerClasses = (0, classnames_1.default)(classes.infoBarLower, (_c = {},
        _c[classes.infoBarLowerSmall] = layout.breakpoint !== "large",
        _c[classes.infoBarLowerHover] = isHovering,
        _c));
    return (react_1.default.createElement("div", { className: infoBarContainerClasses },
        layout.breakpoint !== "small" && (react_1.default.createElement("div", { className: classes.infoBarUpper },
            react_1.default.createElement(PerformerItemStarRating_1.PerformerItemStarRating, { stars: stars }))),
        react_1.default.createElement("div", { className: infoBarMainClasses, id: "Performer_".concat(performerData.id) },
            isLoading && react_1.default.createElement("div", { className: classes.previewLoadingIndicator }),
            react_1.default.createElement(FavoriteButton_1.FavoriteButton, { isFavorite: isFavorite, onClick: props.onFavoriteIconClicked ? _onFavoriteIconClick : undefined }),
            react_1.default.createElement("div", { className: "performer_name_data, " + classes.nickname, "data-ta-locator": "InfoBar-Nickname" }, isTextBlurEnabled ? (react_1.default.createElement(HiddenText_1.HiddenText, { text: nickname, opacity: 0.6, dynamicUpperRangeThreshold: 15, dynamicWidthRange: { lowerRange: 50, upperRange: 70 } })) : (nickname)),
            country && age && (react_1.default.createElement("div", { className: classes.detailsWrapper },
                isOnline && react_1.default.createElement(LiveStatusBug_1.LiveStatusBug, { size: 10 }),
                react_1.default.createElement(Flag_1.Flag, { code: country.toLowerCase() }),
                react_1.default.createElement("div", { className: classes.detailsDivider }),
                react_1.default.createElement("span", { className: "performer_age_data" }, age)))),
        headline && (react_1.default.createElement("div", { className: infoBarLowerClasses, "data-ta-locator": "InfoBar-Headline" }, headline))));
};
exports.PerformerItemInfoBar = PerformerItemInfoBar;
//# sourceMappingURL=PerformerItemInfoBar.js.map